import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth, useOrganization } from '@clerk/react';
import AccountMenu from './AccountMenu';
import { hasDashboardAdminRole } from '../utils/auth';

const Navbar = () => {
  const { isLoaded, isSignedIn, orgRole, sessionClaims } = useAuth();
  const { organization } = useOrganization();
  const isGlobalAdmin = hasDashboardAdminRole(sessionClaims);

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <AppBar 
      position="fixed" 
      color="transparent" 
      elevation={0}
      sx={{
        background: 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(8px)'
      }}
    >
      <Toolbar>
        <Typography
          variant="h6"
          component={RouterLink}
          to="/"
          onClick={handleLogoClick}
          sx={{
            flexGrow: 1,
            textDecoration: 'none',
            color: 'primary.main',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          NILUS
        </Typography>
        <Box component="div" sx={{ display: 'flex', gap: 2 }}>
          <Button
            component={RouterLink}
            to="/"
            color="primary"
            sx={{
              fontWeight: 600,
              fontSize: '0.95rem',
              position: 'relative',
              overflow: 'hidden',
              background: 'linear-gradient(45deg, #2196f3 0%, #64b5f6 100%)',
              color: 'white',
              borderRadius: '8px',
              padding: '8px 16px',
              textTransform: 'none',
              boxShadow: '0 4px 15px rgba(33, 150, 243, 0.3)',
              transition: 'all 0.3s ease',
              animation: 'gentlePulse 3s ease-in-out infinite',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(33, 150, 243, 0.4)',
                background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
              },
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: '-100%',
                width: '100%',
                height: '100%',
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                transition: 'left 0.6s',
              },
              '&:hover::before': {
                left: '100%',
              }
            }}
          >
            ✨ Explore All Glaciers
          </Button>

          {isLoaded && !isSignedIn && (
            <Button
              component={RouterLink}
              to="/login"
              color="primary"
              variant="outlined"
              sx={{ textTransform: 'none' }}
            >
              Sign in
            </Button>
          )}
          {isLoaded && isSignedIn && (
            <>
              <Button
                component={RouterLink}
                to="/dashboard"
                color="primary"
                variant="outlined"
                sx={{ textTransform: 'none' }}
              >
                Dashboard
              </Button>
              {!isGlobalAdmin && organization && (
                <Button
                  component={RouterLink}
                  to="/dashboard/company"
                  color="primary"
                  variant="contained"
                  sx={{ textTransform: 'none' }}
                >
                  {organization.name}
                </Button>
              )}
              {!isGlobalAdmin && orgRole === 'org:admin' && (
                <Button
                  component={RouterLink}
                  to="/dashboard/users"
                  color="primary"
                  variant="outlined"
                  sx={{ textTransform: 'none' }}
                >
                  Company users
                </Button>
              )}
              <AccountMenu />
            </>
          )}
        </Box>
      </Toolbar>
      
      {/* Add CSS animations */}
      <style>
        {`
          @keyframes gentlePulse {
            0%, 100% { 
              transform: scale(1);
              box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3);
            }
            50% { 
              transform: scale(1.02);
              box-shadow: 0 6px 20px rgba(33, 150, 243, 0.4);
            }
          }
        `}
      </style>
    </AppBar>
  );
};

export default Navbar; 